import { render, staticRenderFns } from "./GridTableCpt.vue?vue&type=template&id=16c74316&scoped=true&"
import script from "./GridTableCpt.vue?vue&type=script&lang=ts&"
export * from "./GridTableCpt.vue?vue&type=script&lang=ts&"
import style0 from "./GridTableCpt.vue?vue&type=style&index=0&id=16c74316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c74316",
  null
  
)

export default component.exports